import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import AboutHero from './components/AboutHero';
import WhoWeAre from './components/WhoWeAre';
import FutureEngineering from './components/FutureEngineering';
import MissionVision from './components/MissionVision';
import ExpertiseSection from './components/ExpertiseSection';
import ApproachSection from './components/ApproachSection';

const AboutVastech = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>About VASTECH | Engineering Excellence in HVAC & Elevator Solutions</title>
        <meta name="description" content="Learn about VASTECH, a leading engineering solutions provider in the UAE specializing in advanced HVAC systems, smart elevators, and building infrastructure." />
        <meta name="keywords" content="VASTECH, about us, engineering excellence, HVAC UAE, elevator solutions Sharjah, smart building technology" />
        <meta property="og:title" content="About VASTECH | Engineering Excellence" />
        <meta property="og:description" content="Discover our journey from an installation firm to a regional leader in sustainable and technology-driven infrastructure." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://vastech.ae/about-vastech" />
      </Helmet>

      <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-accent/30">
        <Header />

        <main className="relative">
          {/* About Hero Section */}
          <AboutHero />

          {/* Who We Are */}
          <WhoWeAre />

          {/* Engineering the Future */}
          <FutureEngineering />

          {/* Mission & Vision */}
          <MissionVision />

          {/* Our Expertise */}
          <ExpertiseSection />

          {/* Our Approach */}
          <ApproachSection />
        </main>

        {/* Minimalistic Footer (Consistent with Homepage) */}
        <Footer />
      </div>
    </>
  );
};

export default AboutVastech;